const e = {
  undo: "Ångra",
  redo: "Gör om",
  confirm: "Bekräfta",
  clear: "Rensa",
  more: "Mer",
  cancel: "Avbryt",
  update: "Uppdatera"
}, a = {
  positiveText: "Bekräfta",
  negativeText: "Avbryt"
}, t = {
  placeholder: "Välj",
  loading: "Läser in"
}, r = {
  clear: "Rensa",
  now: "Nu",
  confirm: "Bekräfta",
  selectTime: "Välj tid",
  selectDate: "Välj datum",
  datePlaceholder: "Välj datum",
  datetimePlaceholder: "Välj datum och tid",
  monthPlaceholder: "Välj månad",
  yearPlaceholder: "Välj år",
  quarterPlaceholder: "Välj kvartal",
  startDatePlaceholder: "Startdatum",
  endDatePlaceholder: "Slutdatum",
  startDatetimePlaceholder: "Startdatum och tid",
  endDatetimePlaceholder: "Slutdatum och tid",
  startMonthPlaceholder: "Startmånad",
  endMonthPlaceholder: "Slutmånad",
  today: "Idag"
}, l = {
  checkTableAll: "Markera alla i tabellen",
  uncheckTableAll: "Avmarkera alla i tabellen",
  confirm: "Bekräfta",
  clear: "Rensa",
  apply: "Tillämpa",
  filters: "Filter",
  sort: "Sortera"
}, n = {
  sourceTitle: "Källa",
  targetTitle: "Mål"
}, o = {
  selectAll: "Markera alla",
  unselectAll: "Avmarkera alla",
  clearAll: "Rensa"
}, i = {
  description: "Inga data"
}, c = {
  placeholder: "Välj"
}, d = {
  placeholder: "Välj tid",
  positiveText: "OK",
  negativeText: "Avbryt",
  now: "Nu"
}, s = {
  goto: "Goto",
  selectionSuffix: "sida",
  next: "Nästa",
  previous: "Föregående"
}, g = {
  add: "Lägg till"
}, m = {
  loading: "Läser in"
}, p = {
  placeholder: "Ange"
}, u = {
  placeholder: "Ange"
}, f = {
  create: "Skapa"
}, h = {
  title: "Temaredigerare",
  clearAllVars: "Rensa alla variabler",
  clearSearch: "Rensa sökning",
  filterCompName: "Filtrera komponentnamn",
  filterVarName: "Filtrera variabelnamn",
  import: "Importera",
  export: "Exportera",
  restore: "Återställ till standard"
}, k = {
  tipPrevious: "Föregående bild (←)",
  tipNext: "Nästa bild (→)",
  tipCounterclockwise: "Moturs",
  tipClockwise: "Medurs",
  tipZoomOut: "Zooma ut",
  tipZoomIn: "Zooma in",
  tipClose: "Stäng (Esc)",
  tipOriginalSize: "Zooma till ursprunglig storlek"
}, P = {
  heading: "Sortera och filtrera",
  sortHeading: "Sortera efter",
  newestFirst: "Nyaste först",
  oldestFirst: "Äldst först",
  ascending: "Asc",
  descending: "Beskrivning",
  apply: "Tillämpa",
  clear: "Rensa",
  cancel: "Avbryt",
  filters: "Filter"
}, T = {
  noMatchingFound: "Inga matchande resultat hittades"
}, S = {
  margin: "Marginal",
  padding: "Utfyllnad",
  reset: "Återställ",
  errorMsg: "Det angivna värdet är ogiltigt."
}, v = {
  brandColors: "Varumärkesfärger",
  noBrandColors: "Du har inte lagt till några varumärkesfärger än.",
  getStarted: "Kom igång",
  add: "Lägg till",
  default: "Standard"
}, b = {
  addColor: "Lägg till ny färg",
  editColor: "Redigera färg",
  add: "Lägg till",
  noData: "Du har inte lagt till några färger ännu.",
  invalidCode: "Ogiltig färgkod",
  defaultColor: "Standardfärger"
}, y = {
  global: e,
  Popconfirm: a,
  Cascader: t,
  DatePicker: r,
  DataTable: l,
  LegacyTransfer: n,
  Transfer: o,
  Empty: i,
  Select: c,
  TimePicker: d,
  Pagination: s,
  DynamicTags: g,
  Log: m,
  Input: p,
  InputNumber: u,
  DynamicInput: f,
  ThemeEditor: h,
  Image: k,
  SortFilter: P,
  IconPicker: T,
  Spacing: S,
  BrandColorPicker: v,
  BrandBoard: b
};
export {
  b as BrandBoard,
  v as BrandColorPicker,
  t as Cascader,
  l as DataTable,
  r as DatePicker,
  f as DynamicInput,
  g as DynamicTags,
  i as Empty,
  T as IconPicker,
  k as Image,
  p as Input,
  u as InputNumber,
  n as LegacyTransfer,
  m as Log,
  s as Pagination,
  a as Popconfirm,
  c as Select,
  P as SortFilter,
  S as Spacing,
  h as ThemeEditor,
  d as TimePicker,
  o as Transfer,
  y as default,
  e as global
};
